import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SearchBar from '../Components/SearchBar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DropdownFlat from '../Components/DropdownFlat'
import authInstance from '../Classes/AuthHandler';
import {requestPODispatchClearance} from '../store/actions/dispatchOrderDetailsActions'
import {connect} from 'react-redux'
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'

 class DashboardTPM extends React.Component {

    constructor(props) {
        super(props);
        this.state={
          PONumber: this.props.location.state.poId,
        
          SupplierDocuments:[
          {   value: 1, Name: "Invoice" ,Doc:"Document1.pdf"},
          {   value: 2, Name: "Packing List(Required)",Doc:"Document2.pdf" },
          {   value: 3, Name: "Lorry Receipt(Required)"  ,Doc:"Document3.pdf" },
          {   value: 4, Name: "E-Way Bill(Required)"   ,Doc:"Document4.pdf" },
          {   value: 5, Name: "Operation Document(Required)"   ,Doc:"Document4.pdf" }],

          SMSDocuments:[
            {   value: 1, Name: "GRN" ,Doc:"Document1.pdf"}],

           Save: [{  value: 1,  transporter: "ABC supplier"},
                    {  value: 2,  transporter: "CDE supplier"},
                    {  value: 3,  transporter: "EFG supplier"},
                ],
            assigntransportermodal:false,
            comments:''
          
            
      }
      
     
      this.comments = this.comments.bind(this);
    
    }
    
  


     handleSelect=(e)=>{
      this.setState({
      selectedpaymentmethod : e.target.value
      })
       
  }         

     comments(event) { 
       this.setState({comments: event.target.value})
      //  console.log(this.state.comments,"comments") ;
      }


      componentDidMount(){
        this.props.requestPODispatchClearance()
      }


    render()
    {

      var roles = authInstance.getRoles()
      var groups = authInstance.getGroups()
      // console.log("roles",roles);
        return(
            <div className="Container-fluid pageheight"  >
               

               <div className="Container-fluid p-4" >
                 
                <div >
                    <div className="col-md-3 pt-2  ">
                       <b>PO No: {this.state.PONumber}</b> 
                    </div>
                    <div className="col-md-3 pt-2  ">
                    <b>PO Item: 10,20</b> 
                    </div>
                    <div className="col-md-3 pt-2 ">
                    <b>WBS No: A0XXXX</b>  
                    </div>  
                    <div className="col-md-3 pt-2 ">
                    <b>Status: </b>  
                    </div>
                </div>
                <br />
                
                <div className="row pl-2 pr-4">
                   <div className="col-md-12 ml-2  red1 border">Documents Dashboard</div> 
                   
                </div>
                <div>
                    <div className="row pl-2 pt-2 pr-4">
                      <div className="col-md-12 ml-2 dispatch-bg border">SMS Documents</div> 
                    </div>

                    <div className="row pl-2 pr-4">
                      <div className="col ml-2 pr-2 ">
                      {this.state.SMSDocuments.map((items,Index)=>
                          <div className="row border  ">
                              
                              <div className="col-md-6 border">{items.Name}</div>
                              <div className="col-md-6 border textcolor">
                               
                                <div className="row">
                                  <div className="col">{items.Doc}</div>
                                  <div className="col">
                                  {roles[12] ?
                                    <FontAwesomeIcon className="align-middle pr-2" icon={"upload"}  color={"black"} title="Upload" size="2x"/>
                                    :<></>}
                                  </div>
                                </div>
                                
                                  </div>
                                
                          </div>
                      )}
                      </div>
                    </div>
                </div>
                <div>
                    <div className="row pl-2 pr-4">
                      <div className="col-md-12 ml-2 dispatch-bg border">Supplier Documents</div> 
                    </div>

                    <div className="row pl-2 pr-4 ">
                      <div className="col ml-2 pr-2 ">
                         
                         {this.state.SupplierDocuments.map((item,index)=>
                         
                          <div className="row border  ">
                              
                              <div className="col-md-6 border">
                                {item.Name}
                                
                              </div>
                              <div className="col-md-6 border textcolor">
                                <div className="row">
                                  <div className="col-md-4">{item.Doc}
                                </div>
                                  <div className="col">
                                   {roles[5] ?
                                    <FontAwesomeIcon className="col-md-2-align-middle pr-2 " icon={"upload"}  color={"black"} title="Upload" size="2x"/>
                                    :<></>}
                                    {roles[1]||roles[6]||roles[15]||roles[9]||roles[16] ||roles[14]?<>  
                                      {!roles[9]&&!roles[14] &&!roles[16]&&!roles[1]&&!roles[6]?<>
                                        {/* <button className="btn2 btn-sms1 rounded  float-right ">Reject</button> */}
                                        <button className=" btn2 btn-sms2 rounded  float-right ">Waive Off</button>
                                      </>:<></>} 
                                        <button className="btn2 btn-sms3 rounded  float-right   ">View</button>
                                      
                                    </>:<></>}
                                    
                                    {/* onClick={this.assigntransportermodal} */}
                                  </div>
                                </div>
                                
                                </div>
                              
                          </div>
                          )}
                      </div>
                    </div>
                    {roles[12]?<>
                      <Link  to ={{ pathname: '',state : { } }}>
                       <button className="btn2 btn-sms1 mt-4 rounded  float-right btn-success">Send to Vendor</button>
                     </Link></>:<></>}
                     {roles[12]||roles[15]?<>
                    <Link  to ={{ pathname: '',state : { } }}>
                    <button className="btn2 btn-sms1 mt-4 rounded  float-right ">Save</button>
                   </Link></>:<></>}
                   
                  
                </div>
                
                
  
            </div>
            </div>
            
        )
    }
}

const mapStateToProps  = (state) => ({requestPo:state.dispatchOrderDetailsReducer})
export default connect(mapStateToProps,{requestPODispatchClearance}) (DashboardTPM)
